import styled from 'styled-components';
import { theme } from '../../styles/theme';
const handleColors = ($color) => {
    switch ($color) {
        case 'brandPrimary':
            return `background: ${theme.colors.backgroundBrand}; border-color: ${theme.colors.backgroundBrand}; color: ${theme.colors.textInverted}`;
        case 'brandSecondary':
            return `background: ${theme.colors.backgroundBrandSecondary}; border-color: ${theme.colors.backgroundBrandSecondary}; color: ${theme.colors.text}`;
        case 'error':
            return `background: ${theme.colors.errorBackground}; border-color: ${theme.colors.errorForeground}; color: ${theme.colors.text}`;
        case 'info':
            return `background: ${theme.colors.infoBackground}; border-color: ${theme.colors.infoForeground}; color: ${theme.colors.text}`;
        case 'neutral':
            return `background: ${theme.colors.backgroundLight}; border-color: ${theme.colors.borderDark}; color: ${theme.colors.text}`;
        case 'success':
            return `background: ${theme.colors.successBackground}; border-color: ${theme.colors.successForeground}; color: ${theme.colors.text}`;
        case 'warning':
            return `background: ${theme.colors.warningBackground}; border-color: ${theme.colors.warningForeground}; color: ${theme.colors.text}`;
        default:
            return `background: ${theme.colors.backgroundPrimary}; border-color: ${theme.colors.borderDark}; color: ${theme.colors.text}`;
    }
};
export const Wrapper = styled.button `
  ${theme.typography.label};
  align-items: center;
  border: 1px solid ${theme.colors.borderDark};
  border-radius: ${theme.spacing.xxs};
  ${({ $color }) => handleColors($color)};
  display: inline-flex;
  gap: ${theme.spacing.xs};
  line-height: 1.375em;
  padding-inline: ${theme.spacing.xs};
`;
